import React from 'react'
import { Flex, Image, Heading, Text, Box, useColorModeValue} from '@chakra-ui/react'
import { NavLink } from "react-router-dom";

const MainProjectCard = ({route,title,description, image}) => {
  const descColor= useColorModeValue('gray.600', 'gray.500')
  return (
    
    <Flex mb={'2rem'}minH={{lg:'420px'}} as={NavLink} to={route} overflow={'hidden'} _hover={{ border:'2px solid #417fcc' }}  w={['100%', '70%', '40%', '40%', '40%', '40%']} borderRadius={'10px'} border={'2px solid gray'} direction={'column'}>
      <Image src={image}/>
      <Box p={'15px'}>
      <Heading size={['md','md','md','lg','lg','lg']} mb={'20px'}>{title}</Heading>
      <Text color={descColor}>{description}</Text>
      <Text color={'#417fcc'} textDecor={'underline'} textAlign={'center'} mt={'1rem'}>Continue reading</Text>
      </Box>
    </Flex>
    
  )
}

export default MainProjectCard